'use strict';

import {Component, Input, Output, EventEmitter} from "@angular/core";
import {Transaction} from "../../services/captable/transaction";
const checkboxHtml = <string>require('text!./checkbox.html');

@Component({
    selector: 'checkbox',
    template: checkboxHtml,
})
export class CheckboxComponent {
    @Input() tran: Transaction;
    @Output() tranChange = new EventEmitter();
    @Input() key: string | boolean;
    @Output() keyChange = new EventEmitter();

    constructor() {
    }

    value(): boolean {
        if (this.tran) {
            let key = <string>this.key;
            if (key.indexOf('NOSAVE') > -1) {
                return (<any>this.tran)[key];
            }
            return (<any>this.tran.attrs[key]);
        }
        return <boolean>this.key;
    }

    toggle() {
        if (this.tran) {
            let key = <string>this.key;
            if (key.indexOf('NOSAVE') > -1) {
                (<any>this.tran)[key] = !(<any>this.tran)[key];
            } else {
                if (this.tran.attrs[key]) {
                    delete this.tran.attrs[key];
                } else {
                    this.tran.attrs[key] = true;
                }
            }
        } else {
            this.key = !<boolean>this.key;
        }
        this.keyChange.emit(this.key);
        this.tranChange.emit(this.tran);
    }
}



// WEBPACK FOOTER //
// ./_src/ui/elements/checkbox.ts